import * as classes from './Testimonials.module.css'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

const Testimonials = ({ image, ctaButton, text }) => {
  if (!text) return (<></>)

  return (
    <section className={`container-text ${classes.testimonials}`} style={image ? { backgroundImage: `url(${image?.url}?fm=webp)`, background: 'cover' } : ''}>
      <div className={`container-xs ${classes.content}`}>
        {documentToReactComponents(text)}
      </div>
      {ctaButton && <div className={classes.cta}>
        <a href={ctaButton.fields?.url} target={ctaButton.fields?.target} className={'button'}>
          {ctaButton.fields?.title}
        </a>
      </div>}
    </section>
  )
}

export default Testimonials
